import type {GuidedV2ResultQuickLinkUiProvider, QuickLinkHandlers} from '../guided2/models/ui';
import {predefinedConfigs} from './services/guided-v2-service/predefined-config';
import {type GuidedV2StrategyParams, type GuidedV2Schema} from '../guided2/models/Guided.schema';


type GuidedStrategyObserver = (service:GuidedV2StrategyService)=>void;
type RemoveListenerCallback = ()=>void;

export abstract class GuidedV2StrategyService {
  protected _details: GuidedV2StrategyParams;

  public loadPredefined(name: string){
      if(name in predefinedConfigs){
        this.details = {
          ...this.details,
          ...predefinedConfigs[name]
        };
      }
  }

  get details(): GuidedV2StrategyParams {
      return this._details;
  }
  set details(value: GuidedV2StrategyParams) {
      this._details = value;
      this.triggerCallbacks();
  }


  protected detailsChangedCallbacks: Array<GuidedStrategyObserver> = [];
  protected triggerCallbacks() {
      for (const callback of this.detailsChangedCallbacks) {
        callback(this);
      }
  }
  public onStrategyDetailsChange(callback: GuidedStrategyObserver): RemoveListenerCallback {
      this.detailsChangedCallbacks.push(callback);
      return () => {
          this.detailsChangedCallbacks = this.detailsChangedCallbacks.filter(cb => cb !== callback);
      };
  }

  abstract getSchema(): GuidedV2Schema;

  abstract getQuickLinkTemplateMapper(quickLinkHandlers:QuickLinkHandlers): GuidedV2ResultQuickLinkUiProvider;
}

export interface GuidedV2StrategyData {
  strategyType: string,
  params: Partial<GuidedV2StrategyParams>,
}


export const GuidedV2Defaults: GuidedV2StrategyParams = {
  debounceTimeMs: 500,
  backendTimeoutMs: 7500,
  useBackdrop: true,
  enableBackgroundScroll: false, //GS v1 has false default
  quickLinkTemplateMapperType: 'default',
  badgeHighlightThreshold: 0.04,
  markupHighlightThreshold: 0.02,
  schema: {
    minLength: 3,
    sections: [],
  }
};
